"use strict";
import Auth from "../util/auth";
var ModuleDropdown = React.createClass({
  propTypes: {
    location: React.PropTypes.object
  },
  render: function() {
    if (Auth.isAuthenticated() && this.showDropdown()) {
      return this.dropdownMenu();
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  dropdownTitle: function() {
    if (this.props.location.pathname === "/to_be_scraped_loads") {
      return /* @__PURE__ */ React.createElement("a", { href: "/app/to_be_scraped_loads" }, " Documents ");
    } else if (this.props.location.basename.match(/customer_invoicing/)) {
      return /* @__PURE__ */ React.createElement("a", { href: "/customer_invoicing" }, " Receivables ");
    } else if (this.props.location.pathname !== "/login") {
      return /* @__PURE__ */ React.createElement("a", { href: "/app/dashboard" }, " Payables ");
    }
  },
  dropdownMenu: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: "left", id: "module-dropdown" }, /* @__PURE__ */ React.createElement("li", { className: "has-dropdown not-click" }, this.dropdownTitle(), /* @__PURE__ */ React.createElement("ul", { className: "dropdown" }, this.possibleDocumentsLink(), this.possiblePayablesLink(), this.possibleReceivablesLink(), this.possibleCustomerRepresentativeLink(), this.possibleInsightsDashboardLink())));
  },
  possibleDocumentsLink: function() {
    if (this.showDocuments()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/app/to_be_scraped_loads" }, "Documents"));
    }
  },
  possiblePayablesLink: function() {
    if (this.showPayables()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/app/dashboard" }, "Payables"));
    }
  },
  possibleReceivablesLink: function() {
    if (this.showReceivables()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/customer_invoicing" }, "Receivables"));
    }
  },
  possibleCustomerRepresentativeLink: function() {
    if (this.showCustomerRepresentative()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/customer_representative" }, "Customer Representative"));
    }
  },
  possibleInsightsDashboardLink: function() {
    if (this.showInsightsDashboard()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/insights_dashboard" }, "Insights"));
    }
  },
  showDropdown: function() {
    return _.filter(
      [this.showDocuments(), this.showPayables(), this.showReceivables(), this.showCustomerRepresentative(), this.showInsightsDashboard()],
      function(i) {
        return i;
      }
    ).length > 1;
  },
  showDocuments: function() {
    return this.account().scraper_account;
  },
  showPayables: function() {
    return this.account().payables_account || this.account().factor_account;
  },
  showReceivables: function() {
    return this.account().receivables_account && this.currentUser().receivables;
  },
  showCustomerRepresentative: function() {
    return this.account().customer_representative_view_enabled && this.currentUser().customer_representative;
  },
  showInsightsDashboard: function() {
    const insightsDashboardEnabled = this.account().payables_account || this.account().settings.insights_dashboard_enabled;
    return insightsDashboardEnabled && this.currentUser().insights_dashboard_access;
  },
  account: function() {
    return Auth._currentUser.account;
  },
  currentUser: function() {
    return Auth._currentUser;
  }
});
export default ModuleDropdown;
